import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { toast } from 'sonner';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { ExternalLink, Save } from 'lucide-react';

export function ExternalURLsPanel() {
  const [urls, setUrls] = useState({
    supplier_portal_url: `${window.location.origin}/supplier-portal`,
    public_tenders_url: `${window.location.origin}/public_RFX`,
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/api/admin/environment-settings').then(r => {
      const s = r.data?.settings || r.data || {};
      if (s.supplier_portal_url) setUrls(u => ({ ...u, supplier_portal_url: s.supplier_portal_url }));
      if (s.public_tenders_url) setUrls(u => ({ ...u, public_tenders_url: s.public_tenders_url }));
    }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/api/admin/environment-settings', urls);
      toast.success('URLs saved');
    } catch { toast.error('Save failed'); }
    setSaving(false);
  };

  const links = [
    { key: 'supplier_portal_url', label: 'Supplier Portal', desc: 'Where suppliers register, log in, and respond to bids' },
    { key: 'public_tenders_url', label: 'Public Tenders / Bidding', desc: 'Public-facing page showing open RFQs and RFPs' },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold mb-1">External Portal URLs</h1>
      <p className="text-sm text-muted-foreground mb-6">Links to public-facing portals. Click "Open" to launch in a new window.</p>

      <div className="space-y-4 max-w-2xl">
        {links.map(l => (
          <div key={l.key} className="border rounded-xl p-4">
            <div className="flex items-center justify-between mb-2">
              <div>
                <p className="font-semibold text-sm">{l.label}</p>
                <p className="text-[10px] text-muted-foreground">{l.desc}</p>
              </div>
              <Button size="sm" variant="outline" onClick={() => window.open(urls[l.key], '_blank')}>
                <ExternalLink className="h-3.5 w-3.5 mr-1" /> Open
              </Button>
            </div>
            <Input value={urls[l.key]} onChange={e => setUrls(u => ({ ...u, [l.key]: e.target.value }))} className="h-8 text-sm" />
          </div>
        ))}
        <Button onClick={save} disabled={saving}><Save className="h-3.5 w-3.5 mr-1" /> {saving ? 'Saving...' : 'Save URLs'}</Button>
      </div>
    </div>
  );
}
